import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "plan-content"
}
const _hoisted_2 = {
  id: "update-personal-info-form",
  class: "form update-personal-info"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "body-text" }, " Home Local ", -1)
const _hoisted_4 = { class: "action-buttons pdt-50 sm-pdr-0 sm-pdl-0 sm-pdt-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_MultiStep = _resolveComponent("MultiStep")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_DateInput = _resolveComponent("DateInput")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_UpdateInfoStep2 = _resolveComponent("UpdateInfoStep2")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertsComponent, {
      info: _ctx.info,
      errors: _ctx.errors
    }, null, 8, ["info", "errors"]),
    _createVNode(_component_MessageCard, {
      message: "Enter the information you wish to update in the applicable field. Any changes and/or accompanying documentation will be reviewed by our administrative team prior to being made permanent. Note that all fields marked with an asterisk are required fields.",
      type: "primary",
      iconClass: "iatse-icon-alarm",
      classes: "info_card_full"
    }),
    _createVNode(_component_MultiStep, {
      steps: 2,
      activeStep: _ctx.currentStep,
      classes: "steps-wrapper_secondary sm-pdt-10"
    }, null, 8, ["activeStep"]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_ctx.currentStep === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("form", _hoisted_2, [
              _createVNode(_component_TextInput, {
                type: "text",
                label: "Participant ID",
                placeholder: "Enter Participant ID",
                max: 25,
                modelValue: _ctx.formData.PersonID,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.PersonID) = $event)),
                readonly: true
              }, null, 8, ["modelValue"]),
              _createVNode(_component_DateInput, {
                label: "DOB",
                modelValue: _ctx.formData.DateofBirth,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.DateofBirth) = $event)),
                error: _ctx.inputErrors.DateofBirth,
                isRequired: true
              }, null, 8, ["modelValue", "error"]),
              _createVNode(_component_SelectComponent, {
                label: "Salutation",
                selectedOption: _ctx.formData.Salutation,
                "onUpdate:selectedOption": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.Salutation) = $event)),
                options: _ctx.profileStore.salutations,
                singleArrow: true,
                error: _ctx.inputErrors.Salutation
              }, null, 8, ["selectedOption", "options", "error"]),
              _createVNode(_component_TextInput, {
                type: "text",
                label: "First Name",
                placeholder: "Enter First Name",
                max: 12,
                modelValue: _ctx.formData.FirstName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.FirstName) = $event)),
                error: _ctx.inputErrors.FirstName,
                isRequired: true
              }, null, 8, ["modelValue", "error"]),
              _createVNode(_component_TextInput, {
                type: "text",
                label: "Middle Name",
                placeholder: "Enter Middle Name",
                max: 12,
                modelValue: _ctx.formData.MiddleName,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.MiddleName) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_component_TextInput, {
                type: "text",
                label: "Last Name",
                placeholder: "Enter Last Name",
                max: 25,
                modelValue: _ctx.formData.LastName,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.LastName) = $event)),
                error: _ctx.inputErrors.LastName,
                isRequired: true
              }, null, 8, ["modelValue", "error"]),
              _createVNode(_component_SelectComponent, {
                label: "Suffix",
                selectedOption: _ctx.formData.NameSuffix,
                "onUpdate:selectedOption": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.NameSuffix) = $event)),
                options: _ctx.profileStore.nameSuffixes,
                singleArrow: true,
                error: _ctx.inputErrors.Suffix
              }, null, 8, ["selectedOption", "options", "error"]),
              _createVNode(_component_SelectComponent, {
                label: "Gender",
                selectedOption: _ctx.formData.Sex,
                "onUpdate:selectedOption": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.Sex) = $event)),
                options: _ctx.profileStore.genders,
                singleArrow: true,
                error: _ctx.inputErrors.Gender
              }, null, 8, ["selectedOption", "options", "error"]),
              _createVNode(_component_SelectComponent, {
                label: "Marital Status",
                selectedOption: _ctx.formData.MaritalStatus,
                "onUpdate:selectedOption": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.MaritalStatus) = $event)),
                options: _ctx.profileStore.maritalStatuses,
                singleArrow: true,
                error: _ctx.inputErrors.MaritalStatus
              }, null, 8, ["selectedOption", "options", "error"]),
              _createElementVNode("div", {
                class: _normalizeClass(['custom-select links', { 'error': _ctx.inputErrors.HomeLocal }])
              }, [
                _hoisted_3,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.formData.HomeLocal,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.HomeLocal) = $event)),
                  options: _ctx.locals,
                  placeholder: "Type to search local",
                  limit: 1,
                  loading: _ctx.loadingSearch,
                  searchable: true,
                  "close-on-select": true,
                  openDirection: "bottom",
                  label: "value",
                  "track-by": "key",
                  onSearchChange: _ctx.handleSearch
                }, null, 8, ["modelValue", "options", "loading", "onSearchChange"])
              ], 2),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.resetModal && _ctx.resetModal(...args)))
                }, " Discard "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToNextStep && _ctx.goToNextStep(...args)), ["prevent"]))
                }, " Save and Continue ")
              ])
            ])
          ]))
        : (_ctx.currentStep == 2)
          ? (_openBlock(), _createBlock(_component_UpdateInfoStep2, {
              key: 2,
              loadingSubmit: _ctx.loadingSubmit,
              onSubmit: _ctx.submitData,
              onCheckData: _ctx.goToPreviousStep
            }, null, 8, ["loadingSubmit", "onSubmit", "onCheckData"]))
          : _createCommentVNode("", true)
  ], 64))
}